import axios from '../../common/axios.js'
import LoadingBtn from '../../common/ui/loading_btn.vue'
import Input from '../../common/forms/Input.vue'
import Select from '../../common/forms/Select.vue'
import Loading from '../../common/ui/loading_inex.vue'
import Validations from '../../common/mixins/Validations.js'

export default {
	mixins: [Validations],
	data(){
		return {
			loading: true,
			loading_send: false,
			email: '',
			columns: [],
			data: {},
			show_errors: false
		}
	},
	props: ['params'],
	created(){
		let self = this
		axios.get('api=inex/views/{view_code}/invitation/form')
			.then(function (response) {
				self.columns = response.data;
				
				for(let column of self.columns){
					if(column.nullable === true){
						self.data[column.code] = '';
					}else{
						if(column.type == 'text'){
							self.data[column.code] = '';
						}else{
							self.data[column.code] = column.options[0].value;
						}
					}
				};
				
			}).finally(function(error){
				self.loading = false;
			});
	},
	methods:{
		send(){
			let self = this

			if(!this.isValide){
				this.show_errors = true;
				return;
			}

			let email = this.email;
			let data = this.data;

			self.loading_send = true;
			axios.post('api=inex/views/{view_code}/invitation/users/'+email, data).then(function(response){
				console.log('==> response', response);
				self.$store.dispatch('open_modal', {
					code: 'pending_api', 
					params: {
						promise: Promise.resolve(),
						success_title: 'invite_user_success_title',
						success_message: false,
						success_btn_label: 'invite_user_success_btn_label',
						success_btn_callback: function(){
							self.$store.dispatch('open_modal', 'invite_user')
						}
					}
				})
			}).catch(function(error){
				let message = 'invite_user_error_unknown_error';
				if(error?.response?.status == 409){
					message = 'invite_user_error_user_already_exists';
				}
				self.$store.dispatch('open_modal', {
					code: 'pending_api', 
					params: {
						promise: Promise.reject(),
						error_title: 'invite_user_error_title',
						error_message: message,						
					}
				})
			}).finally(function(){
				self.loading_send = false;
			});
		},
		getSelectData(column){
			let options = {
				label: column.label,
				haut: true,
				field: column.code,
				w100: true,
				theme: this.getTheme(column),
				options: this.formatOptions(column.options, column.code),
				empty_label_selected: '+'
			}

			if(column.nullable_label_edit){
				options.empty = '';
				options.empty_label = this.i18n(column.nullable_label_edit);
			}
			if(column.nullable_label_view){
				options.empty_label_selected = this.i18n(column.nullable_label_view);
			}
			if(column.nullable_color_view){
				options.empty_color = column.nullable_color_view;
			}

			return options;
		},
		formatOptions(_options, column_code){
			let self = this;
			let options = [];
			
			_.forEach(_options, function(option){
				options.push({
					value: option.value,
					label: self.i18n(option.name),
					color: option.color,
				});
			});
			return options;
		},
		getTheme(column){
			if(column.format == 'select_1'){
				return 'select-chips-outline';
			}else if(column.format == 'select_2'){
				return 'select-chips';
			}else if(column.format == 'select_3'){
				return 'chips-outline';
			}
			return 'default';
		},
		updateData(column, event){
			console.log('==> updateData', column, event);
			let data = _.cloneDeep(this.data);	
			data[column.code] = event;
			this.data = data;
		},
	},
	computed:{
		isValide(){
			let email = this.email;
			let columns = this.columns;
			let data = this.data;

			this.validate_resetErrors();
			this.validateEmail('email', email, true, 'field_error_email', 'field_error_required');

			for(let column of columns){
				if(column?.nullable === false){
					let value = data[column.code];
					this.validateRequired(column.code, value, 'field_error_required');
				}
			}

			return _.isEmpty(this.errors);
		}
	},
	components: {
		LoadingBtn,
		Input,
		Select,
		Loading
	}
}